import FeaturedVideoPlaylistCard from "@routes/Videos/VideosPage/components/FeaturedVideoPlaylist/FeaturedVideoPlaylistCard";
import { VideoCardProps } from "@routes/Videos/VideosPage/utils/types";

type FeaturedVideoPlaylistPaginationProps = {
  /** The videos to be displayed */
  videos: VideoCardProps[];
  /** The active video */
  activeVideo?: VideoCardProps;
  /** The function to be called when the video is clicked */
  setActiveVideo: React.Dispatch<React.SetStateAction<VideoCardProps>>;
};

/**
 * The Featured Video Playlist Pagination component.
 */
const FeaturedVideoPlaylistPagination = ({
  videos,
  activeVideo,
  setActiveVideo,
}: FeaturedVideoPlaylistPaginationProps): React.ReactElement => {
  const handleOnVideoClick = (video: VideoCardProps) => {
    setActiveVideo(video);
  };

  return (
    <div
      data-testid="featured-video-playlist-pagination-component"
      className="relative after:absolute after:bottom-0 after:right-0 after:top-0 after:w-[100px] after:bg-gradient-to-l after:from-white after:to-transparent"
    >
      <div className="relative mt-4 overflow-x-auto">
        <div className="flex flex-nowrap gap-6">
          {videos.map((video, index) => {
            return (
              <FeaturedVideoPlaylistCard
                key={`${video.id}-${index}`}
                video={video}
                isActive={video.id === activeVideo?.id}
                onVideoClick={handleOnVideoClick}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FeaturedVideoPlaylistPagination;
